import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import type { PayloadAction } from "@reduxjs/toolkit";
import IntroContent from "../../content/IntroContent.json";
import MissionContent from "../../content/MissionContent.json";
import MiddleBlockContent from "../../content/MiddleBlockContent.json";
import ReportOutageContent from "../../content/ReportOutageContent.json";
import { AppState } from "./types";

type initialStateType = {
  appState: AppState;
};
const appState: AppState = {
  loading: false,
  error: null,
  showHeader: false,
  content: {
    intro: IntroContent,
    mission: MissionContent,
    middleBlock: MiddleBlockContent,
    reportOutage: ReportOutageContent,
  },
  feedbackMessage: {
    message: null,
    isError: false,
    open: false,
  }
};

const initialState: initialStateType = {
  appState,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.appState.loading = action.payload;
    },
    showAlert: (state, action) => {
      state.appState.error = action.payload;
    },
    setShowHeader: (state, action: PayloadAction<boolean>) => {
      state.appState.showHeader = action.payload;
    },
    setContent: (state, action) => {
      state.appState.content = {
        ...state.appState.content,
        ...action.payload,
      };
    },
    updateContent: (state, action) => {
      state.appState.content = {
        ...state.appState.content,
        ...action.payload,
      };
    },
    setFeedbackMessage: (state, action) => {
      state.appState.feedbackMessage = action.payload;
    },
  },
});

export const { setLoading, showAlert, setContent, updateContent, setShowHeader, setFeedbackMessage } = appSlice.actions;

export const selectAppState = (state: RootState) => state.app.appState;
